import {
  ConflictError,
  ForbiddenError,
  UnprocessableEntityError,
  errorCodes,
} from "@exceptions";
import type { QuotaExceededPayload } from "@src/modules/member/context/limit-modal-context";
import { emitQuotaExceeded } from "@src/modules/member/context/limit-modal-context/emitter";
import { Mutation, QueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const isQuotaExceeded = (error: unknown): boolean =>
  error instanceof ForbiddenError &&
  typeof error.responseBody === "object" &&
  error.responseBody !== null &&
  (error.responseBody as { error?: string }).error === "quota_exceeded";

export function handleMutationError(
  queryClient: QueryClient,
  error: Error,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
) {
  const meta = mutation.meta;
  const errorKey = meta?.errorKey;

  if (isQuotaExceeded(error)) {
    const payload = (
      (error as ForbiddenError).responseBody as { data?: QuotaExceededPayload }
    ).data;
    if (payload) {
      emitQuotaExceeded(payload);
      return;
    }
  }

  if (error instanceof ConflictError && meta?.handlesOwnConflict) {
    return;
  }

  if (
    errorKey &&
    (error instanceof UnprocessableEntityError ||
      error instanceof ConflictError)
  ) {
    queryClient.setQueryData(["ERROR", errorKey], error);
  } else if (!errorKey && error instanceof ConflictError) {
    toast.error(error.message);
  } else if (
    !errorKey &&
    error instanceof ForbiddenError &&
    error.errorCode !== errorCodes.EMAIL_VERIFICATION_REQUIRED
  ) {
    toast.error(error.message);
  }
}
